
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Newspaper } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { NewsArticle } from '@/types/news';
import NewsArticleCard from '@/components/news/NewsArticleCard';

interface NewsFeaturedArticleProps {
  isLoading: boolean;
  isError: boolean;
  article?: NewsArticle;
}

const NewsFeaturedArticle: React.FC<NewsFeaturedArticleProps> = ({ isLoading, isError, article }) => {
  if (isLoading) {
    return (
      <Card>
        <CardContent className="p-0">
          <Skeleton className="h-[400px] w-full rounded-lg" />
        </CardContent>
      </Card>
    );
  }

  if (isError || !article) {
    return (
      <div className="text-center py-10">
        <p className="text-red-500 mb-4">Failed to load featured article.</p>
        <Button onClick={() => window.location.reload()}>Retry</Button>
      </div>
    );
  }

  return <NewsArticleCard article={article} variant="featured" />;
};

export default NewsFeaturedArticle;
